<template>
	<span class="inline-block align-middle leading-[0]" :style="{ width: `${width}px` }">
		<span class="inline-block align-middle leading-[0]" :style="{ width: `${width}px` }" v-html="icon" />
	</span>
</template>

<script setup lang="ts">
import { ref, toRefs, watch } from 'vue'

const props = withDefaults(
	defineProps<{
		name: string
		width?: number
	}>(),
	{
		width: 20
	}
)

const icons: any = process.client ? inject('icons') : {}

const { name } = toRefs(props)
const icon = ref('')

const getIcon = async () => {
	if (!icons) return ''
	
	const path = `/assets/svg/${props.name}.svg`
	const iconValue: Function = icons[path]

	if (iconValue) icon.value = await iconValue()
}

if (process.client) watch(name, getIcon, { immediate: true })
</script>
